import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import numeral from 'numeral';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import SaleIcon from '@wix/da-ds/pkg/Icons/24x24/Sale';
import Countdown from '@wix/da-ds/pkg/Time/Countdown';
import { formatDollars } from '../../../utils/formatting';
import s from './OfferBanner.scss';
/** Adoptables buyer/offer banner */ export const OfferBanner = ({ offerEndTime, highestOffer, minOffer, ownOffer, numOffers, className, deviation, onEnd })=>{
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const mobileSuffix = isMobile ? '.mobile' : '';
    if (!offerEndTime) {
        return null;
    }
    const ownOfferDollarPrice = ownOffer === null || ownOffer === void 0 ? void 0 : ownOffer.dollarPrice;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    }, /*#__PURE__*/ React.createElement(SaleIcon, {
        className: s['icon'],
        size: IconSize.MEDIUM
    }), /*#__PURE__*/ React.createElement("span", {
        className: s['offer-info']
    }, /*#__PURE__*/ React.createElement(Countdown, {
        prefix: t(`offerBanner.endsCountdown${mobileSuffix}`),
        countToDate: offerEndTime,
        renderTimer: renderTimer,
        onEnd: onEnd,
        endedMessage: t('offerBanner.saleEnded')
    })), !!minOffer && /*#__PURE__*/ React.createElement("span", {
        className: s['offer-info']
    }, t(`offerBanner.startingPrice${mobileSuffix}`, {
        postProcess: [
            'reactPostprocessor',
            'featureBrancher'
        ],
        price: /*#__PURE__*/ React.createElement("b", null, formatDollars(minOffer))
    })), !!highestOffer && /*#__PURE__*/ React.createElement("span", {
        className: s['offer-info']
    }, t(`offerBanner.highestOffer${mobileSuffix}`, {
        postProcess: [
            'reactPostprocessor',
            'featureBrancher'
        ],
        price: /*#__PURE__*/ React.createElement("b", null, formatDollars(highestOffer))
    })), !!ownOfferDollarPrice && /*#__PURE__*/ React.createElement("span", {
        className: s['offer-info']
    }, t(`offerBanner.myOffer${mobileSuffix}`, {
        postProcess: [
            'reactPostprocessor',
            'featureBrancher'
        ],
        price: /*#__PURE__*/ React.createElement("b", null, formatDollars(ownOfferDollarPrice))
    })), !ownOffer && !!numOffers && /*#__PURE__*/ React.createElement("span", {
        className: s['offer-info']
    }, t(`offerBanner.numOffers${mobileSuffix}`, {
        postProcess: [
            'reactPostprocessor',
            'featureBrancher'
        ],
        offers: /*#__PURE__*/ React.createElement("b", null, `${numOffers}`)
    })));
};
export default OfferBanner;
// ----
function renderTimer(d, h, m, sec) {
    const hasEnded = d + h + m + sec <= 0;
    const countdownString = [
        d,
        h,
        m,
        sec
    ].map((n)=>numeral(n).format('00')).join(':');
    const classNames = classnames(s['countdown'], hasEnded && s['countdown-ended']);
    return /*#__PURE__*/ React.createElement("span", {
        className: classNames
    }, countdownString);
}

//# sourceMappingURL=OfferBanner.js.map